// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1OtWX","bigColWidth":"Table_bigColWidth__3_CgX","biggerColWidth":"Table_biggerColWidth__nL14c","row":"Table_row__2waz1","col":"Table_col__3Bk_v"};